































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosStation } from '@/services/api.service';
import MelosCarousel from '@/components/MelosCarousel.vue';
import { MelosPlayerStatus } from '@/components/MelosPlayer.vue';
import VAudioPlayer from 'v-audio-player';
import { StationStatus } from '@/services/api.service';
import MelosCover from '@/components/MelosCover.vue';

@Component({
  components: {
    MelosCarousel,
    VAudioPlayer,
    MelosCover,
  },
})
export default class MelosStations extends Vue {
  private selectedItem: number = 0;
  private username: string = '';
  private password: string = '';
  private loggedIn: boolean = false;
  private availableHeight: number = 0;
  private margin: number = 40;

  private mounted() {
    if (!!this.$sessionService.getSessionData() &&
    this.$sessionService.getSessionData().token !== '') {
      this.loggedIn = true;
    }
    this.onStationIdChanged();
    this.onSelectedItemChanged(Math.max(this.selectedItem, 0));
    const windowObj: any = window as any;
    windowObj.addEventListener('resize', this.onWindowSizeChange);
    this.onWindowSizeChange();
  }

  private destroyed() {
    const windowObj: any = window as any;
    windowObj.removeEventListener('resize', this.onWindowSizeChange);
  }

  @Watch('connectedDevice')
  private onWindowSizeChange() {
    this.availableHeight = this.getAvailableHeight();
  }

  @Watch('playerInterfaceOffset')
  private onPlayerInterfaceOffsetChanged() {
    this.onWindowSizeChange();
  }

  private get showMelosCover(): boolean {
    return this.$store.state.windowData.width >= 760;
  }

  private get carouselHeight(): number {
    return this.$store.state.interfaceData.carouselHeight;
  }

  @Watch('melosStations')
  private onMelosStationsChanged() {
    if (this.melosStations.length > 0) {
      this.selectedItem = 0;
      this.onSelectedItemChanged(this.selectedItem);
    }
  }

  @Watch('stationId')
  private onStationIdChanged() {
    this.selectedItem = this.melosStations.findIndex((station) => station._id === this.stationId);
  }

  private get connectedDevice(): string {
    return this.$store.state.connectedDevice || '';
  }

  private get melosStations(): MelosStation [] {
    const allowedStations = this.$store.state.melosStations || [];
    if (this.$store.state.connectedDevice === undefined) {
      return allowedStations;
    }
    const deviceStations = this.$store.state.deviceStations || [];
    return allowedStations.filter((stationData: MelosStation) => {
      return deviceStations.findIndex((deviceStationData: any) => {
        return deviceStationData._id === stationData._id;
      }) !== -1;
    });
  }

  private get stationId(): string {
    return this.$store.state.player.stationId;
  }

  private get playing(): boolean {
    return this.$store.state.player?.currentStatus === MelosPlayerStatus.PLAYING;
  }

  private get selectedMelosStation(): number {
    return Math.max(-1, this.selectedItem);
  }

  private onSelectedItemChanged(index: number) {
    return Promise.resolve()
    .then(() => {
      this.selectedItem = index;
      if (this.selectedMelosStation < 0 || this.selectedMelosStation - 1 >= this.melosStations.length) {
        return;
      }
      if (!this.loggedIn) {
        return this.onPublicStationSelected();
      } else {
        return this.onPrivateStationSelected();
      }
    });
  }

  private onPublicStationSelected() {
    if (this.selectedMelosStation < 0 || this.selectedMelosStation > this.melosStations.length - 1) {
      return;
    }
    return this.$apiService.tunePublicStation(this.melosStations[this.selectedMelosStation]._id || '')
    .then(() => {
      this.$store.commit('setPlayerData', {
        targetStatus: MelosPlayerStatus.PLAYING,
        stationId: this.melosStations[this.selectedMelosStation]._id,
      });
    });
  }

  private async onPrivateStationSelected(): Promise<any> {
    if (this.selectedMelosStation < 0 || this.selectedMelosStation > this.melosStations.length - 1) {
      return;
    }
    return this.$apiService.tuneStation(this.melosStations[this.selectedMelosStation]._id || '')
    .then(() => {
      this.$store.commit('setPlayerData', {
        targetStatus: MelosPlayerStatus.PLAYING,
        stationId: this.melosStations[this.selectedMelosStation]._id,
      });
    });
  }

  private get playerInterfaceOffset(): number {
    return this.$store.state.interfaceData.showLargeInterface ? 170 : 100;
  }

  private getTopOffset() {
    const topItem: any = this.$refs.topItem;
    if (!topItem) {
      return 0;
    }
    return topItem.getBoundingClientRect().top;
  }

  private getAvailableHeight() {
    const windowObj: any = window as any;
    const documentObj: any = document as any;
    const viewportHeight = windowObj.innerHeight;
    // Chrome changes viewport when addressbar collapses due to vertical scrolling
    const realViweportHeight = Math.min(
      documentObj.documentElement.clientHeight,
      windowObj.screen.height,
      windowObj.innerHeight,
    );
    return viewportHeight - this.getTopOffset() - this.playerInterfaceOffset - this.margin / 2;
  }

}
